import React, { useState } from "react";
import "./header.css";
import Modal from "react-bootstrap/Modal";
import Offcanvas from "react-bootstrap/Offcanvas";
import SideNavbar from "../../Components/Dashboard/MainComponent/sideNavbar";
import { Link, useNavigate } from "react-router-dom";
import { ModalHeader } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { resetUserInfo } from "../../Features/userInfo";
import { resetUser } from "../../reducer/user.reducer";

const Header = () => {
  const dispatch = useDispatch();
  const [notif] = useState([]);

  const navigate = useNavigate();
  const [avatar, setAvatar] = useState(false);

  const getIntial = (item) => {
    const nameArr = item.trim().split(/\s+/);
    const nameIntial = nameArr.map((p) => p[0].toUpperCase());
    return nameIntial.join("");
  };

  const conUser = useSelector((state) => state?.conUser?.user);
  const name = conUser?.name;
  const nameIcon = getIntial(name);
  const limitName = nameIcon.slice(0, 2);
  const email = conUser?.email;
  const words = name.split(" ");
  const companyName = conUser?.company_id?.name || "company_name";
 
  const [show, setShow] = useState(false);
  const [navbar, setNavbar] = useState(false);
  const handleNavbarClose = () => setNavbar(false);
  const handleNavbarShow = () => setNavbar(true);
  const handleCloseAvatar = () => setAvatar(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const logOut = () => {
    sessionStorage.clear();

    dispatch(resetUserInfo());
    dispatch(resetUser({}));
    navigate("/SignIn");
    setAvatar(false);
  };

  return (
    <>
      <div style={{ height: "56px" }}>
        <div className="navbarContainer">
          <div className="navMenu">
            <i className="bi bi-list" onClick={handleNavbarShow}></i>
            <Link to="/dashboard">
              <img src="./images/Logos/pvxLogo.svg" alt="logoIcon"></img>
            </Link>
          </div>
          <div className="navIcons">
            <div className="feedbackIcon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M1.66699 18.3332V3.33317C1.66699 2.87484 1.83033 2.48262 2.15699 2.1565C2.48366 1.83039 2.87588 1.66706 3.33366 1.6665H16.667C17.1253 1.6665 17.5178 1.82984 17.8445 2.1565C18.1712 2.48317 18.3342 2.87539 18.3337 3.33317V13.3332C18.3337 13.7915 18.1706 14.184 17.8445 14.5107C17.5184 14.8373 17.1259 15.0004 16.667 14.9998H5.00033L1.66699 18.3332ZM10.0003 12.4998C10.2364 12.4998 10.4345 12.4198 10.5945 12.2598C10.7545 12.0998 10.8342 11.9021 10.8337 11.6665C10.8331 11.4309 10.7531 11.2332 10.5937 11.0732C10.4342 10.9132 10.2364 10.8332 10.0003 10.8332C9.76421 10.8332 9.56644 10.9132 9.40699 11.0732C9.24755 11.2332 9.16755 11.4309 9.16699 11.6665C9.16644 11.9021 9.24644 12.1001 9.40699 12.2607C9.56755 12.4212 9.76533 12.5009 10.0003 12.4998ZM9.16699 9.1665H10.8337V4.1665H9.16699V9.1665Z"
                  fill="white"
                />
              </svg>{" "}
              Support
            </div>
            <div className="notificationIcon" onClick={handleShow}>
              {notif.length > 0 && <div className="ellipse1" />}
              <i className="bi bi-bell-fill"></i>
            </div>

            <div className="avatar" onClick={() => setAvatar(!avatar)}>
              <div className="ellipse2"></div>
              <h6> {limitName} </h6>
            </div>
          </div>
          <Modal
            show={show}
            onHide={handleClose}
            className="customerNotification"
          >
            <ModalHeader>Notifications</ModalHeader>
            <Modal.Body>
              {notif.map((notification, id) => {
                return (
                  <div key={id} className="newNotification">
                    <img src="./images/Logos/flash.svg" alt="logo" />
                    <div className="right">
                      <div className="head">
                        <p>{notification.designer}</p>
                        <i
                          // onClick={() => removeNotification(notification)}
                          className="bi bi-x"
                        />
                      </div>
                      <p>Order for {notification.siteName} is pending.</p>
                      <p className="date">{notification.date}</p>
                    </div>
                  </div>
                );
              })}
              {notif.length === 0 && (
                <div className="notificationBox">
                  <img src="./images/Logos/flash.svg" alt="logo"></img>
                  <p>No new notifications.</p>
                </div>
              )}
            </Modal.Body>
          </Modal>
          <Modal
            show={avatar}
            onHide={handleCloseAvatar}
            className="avatarModal"
          >
            <Modal.Body className="avatarInfo">
              <div className="upperInfo">{words[0]}</div>
              <div className="infoAvatar">{limitName}</div>
              <div className="lowerInfo">
                <h1>{name}</h1>
                <h1>{companyName}</h1>
                <h1>{email}</h1>
              </div>
              <div className="avatarSettings">
                {/* {userInfo.userType.toLowerCase() === "admin" && (
                  <Link to="/settings">
                    <h1>
                      <i className="bi bi-gear-fill"></i>Settings
                    </h1>
                  </Link>
                )} */}
                <h1 onClick={logOut}>
                  <i className="bi bi-power"></i>LogOut
                </h1>
              </div>
            </Modal.Body>
          </Modal>
          <Offcanvas
            show={navbar}
            onHide={handleNavbarClose}
            className="side-Navbar"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>
                <img src="../images/Logos/Logo.svg" alt="log"></img>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <SideNavbar></SideNavbar>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>
    </>
  );
};

export default Header;
